export const getCornMasaFlourPackage = newProduct => {
  let newCornMasaFlourPackage = {
    UPC: newProduct.UPC,
    CookingType: newProduct.CookingType,
    Size: newProduct.Size,
  }

  return newCornMasaFlourPackage
}

export const updateCornMasaFlourPackage = newProduct => {
  let newCornMasaFlourPackage = {
    UPC: newProduct.UPC,
    CookingType: newProduct.CookingType,
    Size: newProduct.Size,
  }

  return newCornMasaFlourPackage
}
